// LIVENESS GATE. Four components call this. Two of them — CodePreview.js and
// Command.js — reach it AFTER an `await import('prismjs')`, so the page can
// change between the call site and this body. smbls `dispose()` nulls
// `element.parent` (packages/element/src/dispose.js), and the read of
// `this.parent.value` below then threw
// `Cannot read properties of null (reading 'value')` — measured on the served
// catalog whenever pagination replaced the grid mid-import.
//
// Those two callers gate for themselves now, one line before the call. This
// guard stays as the function's OWN contract: it is registered by name, so a
// published tenant module can `el.call` it after any await of its own, and a
// removed element has no preview to paint — answering nothing is the whole
// contract (every caller already does `if (!code) return`). Terminal.js and
// CodeWithTitleAndButtons.js call it synchronously and never reach the guard.
export const getCodePreviewValue = function getCodePreviewValue(val) {
  if (!this.parent) return
  const globalState = this.getRootState()
  const parentPropsValue = this.parent.value
  const value =
    val ||
    (parentPropsValue
      ? this.call('exec', parentPropsValue, this.parent)
      : this.call('exec', this.value, this))
  const framework = globalState?.framework === 'domql' ? 'symbols' : globalState?.framework
  const code = this.call('isObjectLike', value)
    ? value[framework] || value['symbols'] || value['domql']
    : value
  if (!code) return
  const stringifiedCode = this.call('isString', code) ? code : this.call('objectToString', code)
  return this.call('replaceLiteralsWithObjectFields', stringifiedCode)
}
